import { Star } from "lucide-react";

interface Testimonial {
	quote: string;
	name: string;
	role: string;
	emoji: string;
}

const testimonials: Testimonial[] = [
	{
		quote:
			"Dawi made it so easy to find a qualified nurse for my elderly mother. The home visit was professional and caring. Highly recommended!",
		name: "Sarah Ahmed",
		role: "Patient, Alexandria",
		emoji: "👩",
	},
	{
		quote:
			"As a healthcare provider, Dawi has transformed how I manage my practice. The scheduling system is intuitive and my patients love the convenience.",
		name: "Dr. Mohamed Hassan",
		role: "General Physician",
		emoji: "👨‍⚕️",
	},
	{
		quote:
			"The medication reminder feature has been a lifesaver for managing my father's prescriptions. The app is user-friendly and reliable.",
		name: "Fatma Ibrahim",
		role: "Patient Guardian, Alexandria",
		emoji: "👩",
	},
	{
		quote:
			"Booking a cardiologist consultation was seamless. The doctor arrived on time and was very professional. Great service!",
		name: "Omar Khalil",
		role: "Patient, Alexandria",
		emoji: "👨",
	},
];

function StarRating() {
	return (
		<div className="flex items-center gap-0.5">
			{Array.from({ length: 5 }).map((_, i) => (
				<Star
					key={i}
					size={18}
					className="fill-yellow-400 text-yellow-400"
				/>
			))}
		</div>
	);
}

export default function Testimonials() {
	return (
		<section id="testimonials" className="w-full" style={{ backgroundColor: "#eef6fb" }}>
			<div className="max-w-6xl mx-auto px-6 py-20 flex flex-col gap-12">
				{/* Header */}
				<div className="flex flex-col items-center text-center gap-2">
					<h2 className="text-3xl md:text-4xl font-bold text-gray-900">
						What Our Users Say
					</h2>
				</div>

				{/* Cards */}
				<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
					{testimonials.map((t) => (
						<div
							key={t.name}
							className="bg-white rounded-2xl p-5 flex flex-col gap-4 shadow-sm border border-gray-100"
						>
							<StarRating />

							<p className="text-sm text-gray-600 leading-relaxed flex-1">
								"{t.quote}"
							</p>

							<div className="flex items-center gap-3 pt-1 border-t border-gray-100">
								<div className="w-9 h-9 rounded-full bg-orange-100 flex items-center justify-center text-lg flex-shrink-0">
									{t.emoji}
								</div>
								<div className="flex flex-col">
									<span className="text-sm font-semibold text-gray-800">
										{t.name}
									</span>
									<span className="text-xs text-gray-400">{t.role}</span>
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}